import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import React, { useState, useRef, useEffect, useContext, Component } from 'react';
import { Spring } from 'react-spring/renderprops';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDay, useMonth, START_DATE, useDatepicker } from '@datepicker-react/hooks';
import ReactDOM from 'react-dom';
import { animated, useSpring } from 'react-spring/web.cjs';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledAccordion = styled.div(_templateObject());

function Accordion(_ref) {
  var children = _ref.children,
      toggled = _ref.toggled,
      props = _objectWithoutProperties(_ref, ["children", "toggled"]);

  return /*#__PURE__*/React.createElement(Spring, {
    config: {
      tension: 170,
      friction: 22,
      clamp: true
    },
    from: {
      height: 0
    },
    to: {
      height: toggled ? 'auto' : 0
    }
  }, function (styleProps) {
    return /*#__PURE__*/React.createElement(StyledAccordion, _extends({
      style: styleProps
    }, props), children);
  });
}

Accordion.defaultProps = {
  toggled: false
};
Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  toggled: PropTypes.bool
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledExpander = styled.div(_templateObject$1());

function Expander(_ref) {
  var children = _ref.children,
      toggled = _ref.toggled,
      props = _objectWithoutProperties(_ref, ["children", "toggled"]);

  return /*#__PURE__*/React.createElement(Spring, {
    config: {
      tension: 170,
      friction: 22,
      clamp: true
    },
    from: {
      height: 0,
      width: 0
    },
    to: {
      height: toggled ? 'auto' : 0,
      width: toggled ? 'auto' : 0
    }
  }, function (styleProps) {
    return /*#__PURE__*/React.createElement(StyledExpander, _extends({
      style: styleProps
    }, props), children);
  });
}

Expander.defaultProps = {
  toggled: false
};
Expander.propTypes = {
  children: PropTypes.node.isRequired,
  toggled: PropTypes.bool
};

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  display: inline-block;\n  align-items: center;\n  line-height: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  background: ", ";\n  color: ", ";\n  cursor: pointer;\n  text-transform: uppercase;\n\n  ", "\n\n  ", "\n\n  /* Link button styling */\n  ", "\n\n  /* Icon Link button styling */\n  ", "\n\n  /* Icon button styling */\n  ", "\n\n  svg:first-child {\n    margin-right: .5em;\n    margin-left: .5em;\n  }\n\n  svg:last-child {\n    margin-left: .5em;\n    margin-right: .5em;\n  }\n\n  svg:only-child {\n    margin: 0;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = styled.button(_templateObject$2(), function (props) {
  return "".concat(props.theme.button[props.size].lineHeight, "rem");
}, function (props) {
  return "".concat(props.theme.button[props.size].fontSize, "rem");
}, function (props) {
  return props.theme.button.bg;
}, function (props) {
  return props.theme.button.color;
}, function (props) {
  return props.theme.utils.getBoxModel(props.theme.button[props.size].padding, props.theme.button[props.size].border, props.theme.button[props.size].margin);
}, function (props) {
  return props.appearance === 'link' && "\n      padding-left: 0;\n      padding-right: 0;\n      background: none;\n      color: ".concat(props.theme.button.bg, ";\n    ");
}, function (props) {
  return props.as === 'a' && "\n      // display: inline-block;\n      text-decoration: none;\n\n      &:hover {\n        color: white;\n      }\n    ";
}, function (props) {
  return props.as === 'a' && props.icon !== null && "\n      // display: inline-block;\n    ";
}, function (props) {
  return props.icon !== null && "\n    ".concat(props.theme.utils.getBoxModel(props.theme.button.getSize(props.theme.button[props.size].padding, props.icon), props.theme.button[props.size].border, props.theme.button[props.size].margin), ";\n  ");
});
var StyledButtonInner = styled.span(_templateObject2());

function Button(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(StyledButton, props, /*#__PURE__*/React.createElement(StyledButtonInner, null, children));
}

Button.defaultProps = {
  size: 'md',
  icon: null
};
Button.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  appearance: PropTypes.oneOf(['link', 'button']),
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])])
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: ", ";\n  border-radius: ", ";\n\n  ", ";\n\n  & + & {\n    margin-top: ", "rem;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCard = styled.div(_templateObject$3(), function (props) {
  return props.theme.card.boxShadow;
}, function (props) {
  return props.theme.card.borderRadius;
}, function (props) {
  return props.theme.utils.getBoxModel(props.theme.card[props.size].padding, props.theme.card[props.size].border, props.theme.card[props.size].margin);
}, function (props) {
  return props.theme.verticalRhythm;
});

function Card(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(StyledCard, props, children);
}

Card.defaultProps = {
  size: 'md'
};
Card.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node.isRequired
};

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  fill: currentColor;\n  display: inline-block;\n  line-height: ", "rem;\n\n  ", "\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIcon = styled.svg(_templateObject$4(), function (props) {
  return props.theme.verticalRhythm;
}, function (props) {
  switch (props.size) {
    case 'xl':
      return "\n          height: ".concat(props.theme.verticalRhythm * 1.6, "rem;\n          width: ").concat(props.theme.verticalRhythm * 1.6, "rem;\n        ");

    case 'lg':
      return "\n          height: ".concat(props.theme.verticalRhythm * 1.25, "rem;\n          width: ").concat(props.theme.verticalRhythm * 1.25, "rem;\n        ");

    case 'sm':
      return "\n          height: ".concat(props.theme.verticalRhythm * 0.5, "rem;\n          width: ").concat(props.theme.verticalRhythm * 0.5, "rem;\n        ");

    case 'xs':
      return "\n          height: ".concat(props.theme.verticalRhythm * 0.25, "rem;\n          width: ").concat(props.theme.verticalRhythm * 0.25, "rem;\n        ");

    case 'auto':
      return "\n          height: auto;\n          width: auto;\n        ";

    default:
      return "\n          height: ".concat(props.theme.verticalRhythm, "rem;\n          width: ").concat(props.theme.verticalRhythm, "rem;\n        ");
  }
});

function Icon(_ref) {
  var icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["icon"]);

  return /*#__PURE__*/React.createElement(StyledIcon, props, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "/icons.svg#icon-".concat(icon)
  }));
}

Icon.defaultProps = {
  icon: '',
  size: 'md'
};
Icon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'auto'])
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  line-height: ", ";\n  font-size: ", ";\n  width: 100%;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput = styled.input(_templateObject$5(), function (props) {
  return props.theme.utils.getBoxModel(props.theme.input[props.size].padding, props.theme.input[props.size].border, props.theme.input[props.size].margin);
}, function (props) {
  return "".concat(props.theme.input[props.size].lineHeight, "rem");
}, function (props) {
  return "".concat(props.theme.input[props.size].fontSize, "rem");
});
var Input = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(StyledInput, _extends({
    ref: ref
  }, props));
});
Input.defaultProps = {
  size: 'md'
};
Input.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  textarea {\n    line-height: ", ";\n    font-size: ", ";\n    width: 100%;\n  }\n\n  ", "\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTextarea = styled.div(_templateObject$6(), function (props) {
  return props.theme.utils.getBoxModel(props.theme.input[props.size].padding, props.theme.input[props.size].border, props.theme.input[props.size].margin);
}, function (props) {
  return "".concat(props.theme.input[props.size].lineHeight, "rem");
}, function (props) {
  return "".concat(props.theme.input[props.size].fontSize, "rem");
}, function (props) {
  return props.renderAsFormField && "\n      padding-top: ".concat("".concat((props.theme.input[props.size].padding[0] * 2).toFixed(2), "rem"), ";\n      padding-bottom: ", "".concat((props.theme.input[props.size].padding[0] * 0.75).toFixed(2), "rem"), ";\n\n      textarea {\n        border: none;\n        padding: 0;\n        margin: 0;\n      }\n    ");
});
var Textarea = React.forwardRef(function (_ref, ref) {
  var size = _ref.size,
      renderAsFormField = _ref.renderAsFormField,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["size", "renderAsFormField", "value"]);

  return /*#__PURE__*/React.createElement(StyledTextarea, {
    renderAsFormField: renderAsFormField,
    size: size
  }, /*#__PURE__*/React.createElement("textarea", _extends({
    value: value,
    ref: ref
  }, props)));
});
Textarea.defaultProps = {
  size: 'md',
  renderAsFormField: false,
  value: ''
};
Textarea.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  renderAsFormField: PropTypes.bool,
  value: PropTypes.node
};
/**
 * Default validation keys
 */

var getInvalidReasons = function getInvalidReasons(_ref) {
  var badInput = _ref.badInput,
      customError = _ref.customError,
      patternMismatch = _ref.patternMismatch,
      rangeOverflow = _ref.rangeOverflow,
      rangeUnderflow = _ref.rangeUnderflow,
      stepMismatch = _ref.stepMismatch,
      tooLong = _ref.tooLong,
      tooShort = _ref.tooShort,
      typeMismatch = _ref.typeMismatch,
      valueMissing = _ref.valueMissing;
  return {
    badInput: badInput,
    customError: customError,
    patternMismatch: patternMismatch,
    rangeOverflow: rangeOverflow,
    rangeUnderflow: rangeUnderflow,
    stepMismatch: stepMismatch,
    tooLong: tooLong,
    tooShort: tooShort,
    typeMismatch: typeMismatch,
    valueMissing: valueMissing
  };
};

var handleInputValidation = function handleInputValidation(element, validationMessages, customValidationFunction) {
  var messages = validationMessages;

  if (customValidationFunction && element.value.length > 0) {
    var valid = customValidationFunction(element.value);
    return {
      valid: valid,
      message: valid ? null : messages['customError']
    };
  } // Otherwise default to default HTML5 client side validation


  var validity = element.validity;
  var invalidReasons = getInvalidReasons(validity);
  var returnValue = {
    valid: validity.valid,
    message: null
  }; // If not valid, figure out the reason why.

  if (!validity.valid) {
    var invalidReason = Object.keys(invalidReasons).filter(function (reason) {
      return invalidReasons[reason];
    });
    returnValue.message = messages[invalidReason[0]];
  }

  return returnValue;
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  border: ", ";\n  transition: border ease-out 0.15s;\n  ", "\n  ", "\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  border: ", ";\n  transition: border ease-out 0.15s;\n  ", "\n  ", "\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput$1 = styled(Input)(_templateObject$7(), function (props) {
  return props.theme.input[props.size].border[0];
}, function (props) {
  return props.dirty && props.valid === false && "border-color: ".concat(props.theme.colors.danger, ";");
}, function (props) {
  return props.notifyIfValid && props.dirty && props.valid === true && "border-color: ".concat(props.theme.colors.success);
});
var StyledTextarea$1 = styled(Textarea)(_templateObject2$1(), function (props) {
  return props.theme.input[props.size].border[0];
}, function (props) {
  return props.dirty && props.valid === false && "border-color: ".concat(props.theme.colors.danger, ";");
}, function (props) {
  return props.notifyIfValid && props.dirty && props.valid === true && "border-color: ".concat(props.theme.colors.success);
});
var ValidationInput = React.forwardRef(function (_ref, ref) {
  var onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onValidate = _ref.onValidate,
      customValidation = _ref.customValidation,
      revalidate = _ref.revalidate,
      validationMessages = _ref.validationMessages,
      size = _ref.size,
      renderAs = _ref.as,
      props = _objectWithoutProperties(_ref, ["onChange", "onBlur", "onFocus", "onValidate", "customValidation", "revalidate", "validationMessages", "size", "as"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDirty = _useState2[0],
      setDirty = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setFocused = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      isValid = _useState6[0],
      setValidity = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      errorMsg = _useState8[0],
      setErrorMsg = _useState8[1];

  var inputRef = ref || useRef(null);

  function validateInput() {
    var validation = handleInputValidation(inputRef.current, validationMessages, customValidation);
    setValidity(validation.valid);
    setErrorMsg(validation.message);
  }

  function onFocusHandler(e) {
    setFocused(true);
    onFocus(e);
  }

  function onBlurHandler(e) {
    validateInput();
    setFocused(false);
    props.required && setDirty(true);
    onBlur(e);
  }

  function onChangeHandler(e) {
    setDirty(true);
    setValidity(null);
    setErrorMsg(null);
    onChange(e);
  }

  useEffect(function () {
    onValidate(errorMsg, isValid);
  }, [errorMsg, isValid, onValidate]);
  useEffect(function () {
    if (revalidate) validateInput();
  }, [revalidate, validateInput]);
  return renderAs === 'textarea' ? /*#__PURE__*/React.createElement(StyledTextarea$1, _extends({
    renderAsFormField: true,
    ref: inputRef,
    size: size,
    onBlur: onBlurHandler,
    onFocus: onFocusHandler,
    onChange: onChangeHandler,
    dirty: isDirty,
    valid: isValid
  }, props)) : /*#__PURE__*/React.createElement(StyledInput$1, _extends({
    ref: inputRef,
    size: size,
    onBlur: onBlurHandler,
    onFocus: onFocusHandler,
    onChange: onChangeHandler,
    dirty: isDirty,
    valid: isValid
  }, props));
});
ValidationInput.defaultProps = {
  size: 'md',
  revalidate: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onValidate: function onValidate() {},
  customValidation: null,
  notifyIfValid: false
};
ValidationInput.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  revalidate: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onValidate: PropTypes.func,
  customValidation: PropTypes.func,
  notifyIfValid: PropTypes.bool
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  border: ", ";\n  transition: all ease-out 0.15s;\n  ", "\n  ", ";\n  appearance: none;\n  line-height: ", ";\n  font-size: ", ";\n  width: 100%;\n  background: none;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  svg {\n    position: absolute;\n    right: 1rem;\n    bottom: ", ";\n    width: 1.6rem;\n    pointer-events: none;\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSelectWrapper = styled.div(_templateObject$8(), function (props) {
  return "".concat((props.theme.input[props.size].padding[0] * 0.75).toFixed(2), "rem");
});
var StyledSelect = styled.select(_templateObject2$2(), function (props) {
  return props.theme.input[props.size].border[0];
}, function (props) {
  return props.valid === false && "border-color: ".concat(props.theme.colors.danger, ";");
}, function (props) {
  return props.theme.utils.getBoxModel(props.theme.input[props.size].padding, props.theme.input[props.size].border, props.theme.input[props.size].margin);
}, function (props) {
  return "".concat(props.theme.input[props.size].lineHeight, "rem");
}, function (props) {
  return "".concat(props.theme.input[props.size].fontSize, "rem");
});

function Select(_ref) {
  var children = _ref.children,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["children", "size"]);

  return /*#__PURE__*/React.createElement(StyledSelectWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(StyledSelect, _extends({
    size: size
  }, props), children), /*#__PURE__*/React.createElement(Icon, {
    size: size,
    icon: "chevron-down"
  }));
}

Select.defaultProps = {
  size: 'md'
};
Select.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding-left: 0.25em;\n  opacity: ", ";\n  transform: ", ";\n  transition: all ease-out 0.1s;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledErrorMessage = styled.span(_templateObject$9(), function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.show ? "translateY(0)" : "translateY(-100%)";
});

function ErrorMessage(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(StyledErrorMessage, props, children);
}

ErrorMessage.defaultProps = {};
ErrorMessage.propTypes = {
  children: PropTypes.node.isRequired
};

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  transition: all ease-out 0.1s;\n  ", "\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFormLabel = styled.label(_templateObject$a(), function (props) {
  if (typeof props.error === 'boolean') {
    return props.error ? "color: ".concat(props.theme.colors.danger, ";") : "color: ".concat(props.theme.colors.success, ";");
  }

  return "color: currentColor;";
});

function FormLabel(_ref) {
  var error = _ref.error,
      errorMessage = _ref.errorMessage,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["error", "errorMessage", "children"]);

  return /*#__PURE__*/React.createElement(StyledFormLabel, _extends({
    error: error
  }, props), children, /*#__PURE__*/React.createElement(ErrorMessage, {
    show: error
  }, " - ".concat(errorMessage)));
}

FormLabel.defaultProps = {
  error: null,
  errorMessage: null,
  children: null
};
FormLabel.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
  errorMessage: PropTypes.string
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: ", ";\n  font-size: ", ";\n  pointer-events: none;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  & + & {\n    margin-top: 2rem;\n  }\n\n  input {\n    line-height: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin: 0;\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  textarea {\n    resize: vertical;\n    margin: 0;\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  select {\n    line-height: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin: 0;\n    &:focus {\n      outline: 0;\n    }\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFormField = styled.div(_templateObject$b(), function (props) {
  return "".concat((props.theme.input[props.size].padding[0] * 2).toFixed(2), "rem");
}, function (props) {
  return "".concat((props.theme.input[props.size].padding[0] * 0.75).toFixed(2), "rem");
}, function (props) {
  return "".concat((props.theme.input[props.size].padding[0] * 2).toFixed(2), "rem");
}, function (props) {
  return "".concat((props.theme.input[props.size].padding[0] * 0.75).toFixed(2), "rem");
});
var StyledFormLabel$1 = styled(FormLabel)(_templateObject2$3(), function (props) {
  return "".concat(props.theme.input[props.size].padding[0] * 0.3, "rem ").concat(props.theme.input[props.size].padding[1], "rem");
}, function (props) {
  return "".concat(props.theme.input[props.size].fontSize * 0.7, "rem");
});

function FormField(_ref) {
  var children = _ref.children,
      valid = _ref.valid,
      errorMsg = _ref.errorMsg,
      size = _ref.size,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["children", "valid", "errorMsg", "size", "label"]);

  return /*#__PURE__*/React.createElement(StyledFormField, _extends({
    valid: valid,
    size: size
  }, props), /*#__PURE__*/React.createElement(StyledFormLabel$1, {
    size: size,
    error: valid !== null ? !valid : null,
    errorMessage: errorMsg
  }, label), children);
}

FormField.defaultProps = {
  children: null,
  size: 'md',
  valid: null,
  errorMessage: null
};
FormField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  valid: PropTypes.bool,
  errorMsg: PropTypes.string
};

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  line-height: 1;\n\n  p {\n    margin: 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background: ", ";\n  transition: ", ";\n  position: relative;\n  border-radius: ", ";\n  cursor: pointer;\n\n  > span {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    box-shadow: ", ";\n    z-index: 10;\n    width: ", ";\n    height: ", ";\n    background: #fff;\n    border-radius: ", ";\n    transform: ", ";\n    left: 0;\n    top: 0;\n    transition: transform ease-out 0.2s;\n\n    svg {\n      width: 80%;\n      height: 80%;\n      position: relative;\n      z-index: 50;\n      opacity: ", ";\n      transform: ", ";\n      transition: ", ";\n      ", ";\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  border: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n  transition: ", ";\n  cursor: pointer;\n\n  svg {\n    width: 75%;\n    height: 75%;\n    opacity: ", ";\n    fill: ", ";\n    transition: ", ";\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  position: relative;\n  grid-column-gap: ", ";\n  font-size: ", "rem;\n\n  & + & {\n    margin-top: 1em;\n  }\n\n  input {\n    visibility: hidden;\n    position: absolute;\n    pointer-events: none;\n    width: 1px;\n    height: 1px;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCheckbox = styled.div(_templateObject$c(), function (props) {
  return props.theme.checkbox[props.size].marginRight;
}, function (props) {
  return props.theme.checkbox[props.size].fontSize;
});
var StyledCheckboxBox = styled.span(_templateObject2$4(), function (props) {
  return "".concat(props.theme.checkbox[props.size].size, "rem");
}, function (props) {
  return "".concat(props.theme.checkbox[props.size].size, "rem");
}, function (props) {
  return props.theme.checkbox.border;
}, function (props) {
  return props.checked ? props.theme.checkbox.bgActive : props.theme.checkbox.bg;
}, function (props) {
  return props.theme.checkbox.bgTransition;
}, function (props) {
  return props.checked ? 1 : 0;
}, function (props) {
  return props.theme.checkbox.iconColor;
}, function (props) {
  return props.theme.checkbox.iconTransition;
});
var StyledCheckboxToggle = styled.span(_templateObject3(), function (props) {
  return "".concat(props.theme.checkbox[props.size].size * 2, "rem");
}, function (props) {
  return "".concat(props.theme.checkbox[props.size].size, "rem");
}, function (props) {
  return props.checked ? props.theme.checkbox.toggleActive : props.theme.checkbox.toggleInactive;
}, function (props) {
  return props.theme.checkbox.bgTransition;
}, function (props) {
  return "".concat(props.theme.checkbox[props.size].size, "rem");
}, function (props) {
  return "".concat(props.theme.checkbox.toggleShadow);
}, function (props) {
  return "".concat(props.theme.checkbox[props.size].size * 1, "rem");
}, function (props) {
  return "".concat(props.theme.checkbox[props.size].size * 1, "rem");
}, function (props) {
  return "".concat(props.theme.checkbox[props.size].size, "rem");
}, function (props) {
  return props.checked ? "translate3d(105%, 0, 0)" : "translate3d(-5%, 0, 0)";
}, function (props) {
  return props.checked ? 1 : 0;
}, function (props) {
  return props.checked ? "rotateZ(0)" : "rotateZ(-90deg)";
}, function (props) {
  return props.theme.checkbox.iconTransition;
}, function (props) {
  return props.checked && "fill: ".concat(props.theme.colors.success);
});
var StyledCheckboxLabel = styled.label(_templateObject4());

function Checkbox(_ref) {
  var appearance = _ref.appearance,
      id = _ref.id,
      children = _ref.children,
      checked = _ref.checked,
      onChange = _ref.onChange,
      icon = _ref.icon,
      iconUntoggled = _ref.iconUntoggled,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["appearance", "id", "children", "checked", "onChange", "icon", "iconUntoggled", "size"]); // Per default, the check state is initiated with the value we put in. Defaults to false.


  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setChecked = _useState2[1];

  var cbRef = useRef(null);

  function onClickHandler(e) {
    // When we click the checkbox, the local state is switched.
    setChecked(!cbRef.current.checked);
  }

  function onChangeHandler(e) {
    setChecked(e.target.checked);
  }

  useEffect(function () {
    onChange(isChecked);
  }, [isChecked]);
  useEffect(function () {
    if (cbRef.current.checked !== checked) setChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement(StyledCheckbox, {
    size: size
  }, /*#__PURE__*/React.createElement("input", {
    ref: cbRef,
    type: "checkbox",
    checked: isChecked,
    onChange: onChangeHandler
  }), appearance === 'toggle' ? /*#__PURE__*/React.createElement(StyledCheckboxToggle, {
    role: "checkbox",
    "aria-checked": isChecked,
    checked: isChecked,
    size: size,
    onClick: onClickHandler
  }, /*#__PURE__*/React.createElement("span", null, isChecked ? /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  }) : /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  }))) : /*#__PURE__*/React.createElement(StyledCheckboxBox, {
    role: "checkbox",
    "aria-checked": isChecked,
    checked: isChecked,
    size: size,
    onClick: onClickHandler
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  })), /*#__PURE__*/React.createElement(StyledCheckboxLabel, {
    htmlFor: props.id,
    onClick: onClickHandler
  }, children));
}

Checkbox.defaultProps = {
  icon: 'check',
  iconUntoggled: 'close',
  checked: false,
  size: 'md',
  appearance: 'checkbox'
};
Checkbox.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  icon: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  appearance: PropTypes.oneOf(['checkbox', 'toggle'])
};

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */


function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */


function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */


function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */


function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */


function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  cursor: pointer;\n  height: 3.4rem;\n  width: 3.4rem;\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var StyledNav = styled.button(_templateObject$d());

function Nav(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(StyledNav, props, children);
}

Nav.defaultProps = {
  children: null
};
Nav.propTypes = {
  children: PropTypes.node
};
var datepickerContextDefaultValue = {
  focusedDate: null,
  isDateFocused: function isDateFocused() {
    return false;
  },
  isDateSelected: function isDateSelected() {
    return false;
  },
  isDateHovered: function isDateHovered() {
    return false;
  },
  isDateBlocked: function isDateBlocked() {
    return false;
  },
  isFirstOrLastSelectedDate: function isFirstOrLastSelectedDate() {
    return false;
  },
  onDateFocus: function onDateFocus() {},
  onDateHover: function onDateHover() {},
  onDateSelect: function onDateSelect() {}
};
var DatepickerContext = React.createContext(datepickerContextDefaultValue);

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 4rem;\n  height: 4rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var StyledDay = styled.button(_templateObject$e(), function (props) {
  return props.theme.datepicker.isInHoverRange.bg;
}, function (props) {
  return props.theme.datepicker.isInHoverRange.color;
}, function (props) {
  return props.isSelected && "\n    background: ".concat(props.theme.datepicker.isSelected.bg, ";\n    color: ").concat(props.theme.datepicker.isSelected.color, ";\n  ");
}, function (props) {
  return props.isInHoverRange && "\n    background: ".concat(props.theme.datepicker.isInHoverRange.bg, ";\n    color: ").concat(props.theme.datepicker.isInHoverRange.color, ";\n  ");
}, function (props) {
  return props.isStartOrEnd && "\n    background: ".concat(props.theme.datepicker.isStartOrEnd.bg, ";\n    color: ").concat(props.theme.datepicker.isStartOrEnd.color, ";\n  ");
}, function (props) {
  return props.isDisabled && "\n    cursor: normal;\n    background: ".concat(props.theme.datepicker.isDisabled.bg, ";\n    color: ").concat(props.theme.datepicker.isDisabled.color, ";\n  ");
});

function Day(_ref) {
  var dayLabel = _ref.dayLabel,
      date = _ref.date,
      props = _objectWithoutProperties(_ref, ["dayLabel", "date"]);

  var dayRef = useRef(null);

  var _useContext = useContext(DatepickerContext),
      focusedDate = _useContext.focusedDate,
      isDateFocused = _useContext.isDateFocused,
      isDateSelected = _useContext.isDateSelected,
      isDateHovered = _useContext.isDateHovered,
      isDateBlocked = _useContext.isDateBlocked,
      isFirstOrLastSelectedDate = _useContext.isFirstOrLastSelectedDate,
      onDateSelect = _useContext.onDateSelect,
      onDateFocus = _useContext.onDateFocus,
      onDateHover = _useContext.onDateHover;

  var _useDay = useDay({
    date: date,
    focusedDate: focusedDate,
    isDateFocused: isDateFocused,
    isDateSelected: isDateSelected,
    isDateHovered: isDateHovered,
    isDateBlocked: isDateBlocked,
    isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
    onDateFocus: onDateFocus,
    onDateSelect: onDateSelect,
    onDateHover: onDateHover,
    dayRef: dayRef
  }),
      isSelected = _useDay.isSelected,
      isSelectedStartOrEnd = _useDay.isSelectedStartOrEnd,
      isWithinHoverRange = _useDay.isWithinHoverRange,
      disabledDate = _useDay.disabledDate,
      onClick = _useDay.onClick,
      onKeyDown = _useDay.onKeyDown,
      onMouseEnter = _useDay.onMouseEnter,
      tabIndex = _useDay.tabIndex;

  if (!dayLabel) {
    return /*#__PURE__*/React.createElement("div", null);
  }

  return /*#__PURE__*/React.createElement(StyledDay, _extends({
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    type: "button",
    ref: dayRef,
    isSelected: isSelected,
    isStartOrEnd: isSelectedStartOrEnd,
    isInHoverRange: isWithinHoverRange,
    isDisabled: disabledDate
  }, props), dayLabel);
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "rem;\n  height: ", "rem;\n  font-size: ", "rem;\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  grid-area: weekdaylabels;\n  display: grid;\n  grid-template-areas: 'mon tue wed thu fri sat sun';\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-rows: auto;\n  grid-template-columns: repeat(\n    7,\n    ", "\n  );\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  font-size: ", "rem;\n  color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-area: weeknumbers;\n  grid-template-rows: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  grid-area: monthlabel;\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  justify-content: center;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  grid-area: month;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  ", "\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var StyledMonthWrapper = styled.div(_templateObject$f(), function (props) {
  return props.includeWeekNumbers ? "grid-template-areas: \"monthlabel monthlabel\"\n                              \". weekdaylabels\"\n                              \"weeknumbers month\";\n          grid-template-rows: 4rem ".concat(props.theme.datepicker.daylabel.height, "rem 1fr;\n          grid-template-columns: ").concat(props.theme.datepicker.weeknumber.width, "rem 1fr;\n          width: ").concat(props.theme.datepicker.days.width * 8, "rem;\n        ") : "grid-template-areas: \"monthlabel\"\n                              \"weekdaylabels\"\n                              \"month\";\n          grid-template-rows: 4rem ".concat(props.theme.datepicker.daylabel.height, "rem 1fr;\n          grid-template-columns: 1fr;\n          width: ").concat(props.theme.datepicker.days.width * 7, "rem;\n        ");
});
var StyledMonth = styled.div(_templateObject2$5());
var StyledMonthHeader = styled.div(_templateObject3$1());
var StyledMonthLabel = styled.span(_templateObject4$1());
var StyledWeekNumbers = styled.div(_templateObject5());
var StyledWeekNumber = styled.div(_templateObject6(), function (props) {
  return props.theme.datepicker.weeknumber.fontSize;
}, function (props) {
  return props.theme.datepicker.weeknumber.color;
});
var StyledDays = styled.span(_templateObject7(), function (props) {
  return "".concat(props.theme.datepicker.days.width, "rem");
});
var StyledDayLabels = styled.div(_templateObject8());
var StyledDayLabel = styled.span(_templateObject9(), function (props) {
  return props.theme.datepicker.daylabel.width;
}, function (props) {
  return props.theme.datepicker.daylabel.height;
}, function (props) {
  return props.theme.datepicker.daylabel.fontSize;
}, function (props) {
  return props.theme.datepicker.daylabel.color;
});

function Month(_ref) {
  var includeWeekNumbers = _ref.includeWeekNumbers,
      year = _ref.year,
      month = _ref.month,
      firstDayOfWeek = _ref.firstDayOfWeek,
      dayComponent = _ref.dayComponent,
      onGoToNextMonths = _ref.onGoToNextMonths,
      onGoToPreviousMonths = _ref.onGoToPreviousMonths,
      nextButtonComponent = _ref.nextButtonComponent,
      prevButtonComponent = _ref.prevButtonComponent,
      props = _objectWithoutProperties(_ref, ["includeWeekNumbers", "year", "month", "firstDayOfWeek", "dayComponent", "onGoToNextMonths", "onGoToPreviousMonths", "nextButtonComponent", "prevButtonComponent"]);

  var _useMonth = useMonth({
    year: year,
    month: month,
    firstDayOfWeek: firstDayOfWeek
  }),
      days = _useMonth.days,
      weekdayLabels = _useMonth.weekdayLabels,
      monthLabel = _useMonth.monthLabel;

  function renderWeekNumbers() {
    var weekNumbers = days.map(function (day) {
      return getISOWeek(day.date);
    }).filter(function (week) {
      return !Number.isNaN(week);
    }).filter(function (week, index, src) {
      return src.indexOf(week) === index;
    });
    return /*#__PURE__*/React.createElement(StyledWeekNumbers, null, weekNumbers.map(function (week) {
      return /*#__PURE__*/React.createElement(StyledWeekNumber, {
        key: week
      }, week);
    }));
  }

  return /*#__PURE__*/React.createElement(StyledMonthWrapper, _extends({
    includeWeekNumbers: includeWeekNumbers
  }, props), /*#__PURE__*/React.createElement(StyledMonthHeader, null, /*#__PURE__*/React.createElement(prevButtonComponent.type, _extends({
    onClick: onGoToPreviousMonths
  }, prevButtonComponent.props)), /*#__PURE__*/React.createElement(StyledMonthLabel, null, monthLabel), /*#__PURE__*/React.createElement(nextButtonComponent.type, _extends({
    onClick: onGoToNextMonths
  }, nextButtonComponent.props))), includeWeekNumbers && renderWeekNumbers(), /*#__PURE__*/React.createElement(StyledDayLabels, null, weekdayLabels.map(function (dayLabel) {
    return /*#__PURE__*/React.createElement(StyledDayLabel, {
      key: dayLabel
    }, dayLabel);
  })), /*#__PURE__*/React.createElement(StyledMonth, null, /*#__PURE__*/React.createElement(StyledDays, null, days.map(function (day, index) {
    if (_typeof(day) === 'object') {
      return /*#__PURE__*/React.createElement(dayComponent.type, _extends({
        date: day.date,
        key: day.date.toString(),
        dayLabel: day.dayLabel
      }, dayComponent.props));
    }

    return /*#__PURE__*/React.createElement("div", {
      key: index
    });
  }))));
}

Month.defaultProps = {
  nextButtonComponent: /*#__PURE__*/React.createElement(Nav, {
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron-right"
  })),
  prevButtonComponent: /*#__PURE__*/React.createElement(Nav, {
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron-left"
  })),
  dayComponent: /*#__PURE__*/React.createElement(Day, null)
};
Month.propTypes = {
  nextButtonComponent: PropTypes.node,
  prevButtonComponent: PropTypes.node,
  dayComponent: PropTypes.node
};

function Datepicker(_ref) {
  var numberOfMonths = _ref.numberOfMonths,
      minBookingDays = _ref.minBookingDays,
      maxBookingDays = _ref.maxBookingDays,
      exactMinBookingDays = _ref.exactMinBookingDays,
      monthComponent = _ref.monthComponent,
      initialVisibleMonth = _ref.initialVisibleMonth,
      onChange = _ref.onChange;

  var _useState = useState({
    endDate: null,
    startDate: null,
    focusedInput: START_DATE
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useDatepicker = useDatepicker({
    numberOfMonths: numberOfMonths,
    minBookingDays: minBookingDays,
    maxBookingDays: maxBookingDays,
    exactMinBookingDays: exactMinBookingDays,
    initialVisibleMonth: initialVisibleMonth,
    startDate: state.startDate,
    endDate: state.endDate,
    focusedInput: state.focusedInput,
    onDatesChange: handleDateChange
  }),
      firstDayOfWeek = _useDatepicker.firstDayOfWeek,
      activeMonths = _useDatepicker.activeMonths,
      isDateSelected = _useDatepicker.isDateSelected,
      isDateHovered = _useDatepicker.isDateHovered,
      isFirstOrLastSelectedDate = _useDatepicker.isFirstOrLastSelectedDate,
      isDateBlocked = _useDatepicker.isDateBlocked,
      isDateFocused = _useDatepicker.isDateFocused,
      focusedDate = _useDatepicker.focusedDate,
      onDateHover = _useDatepicker.onDateHover,
      onDateSelect = _useDatepicker.onDateSelect,
      onDateFocus = _useDatepicker.onDateFocus,
      goToPreviousMonths = _useDatepicker.goToPreviousMonths,
      goToNextMonths = _useDatepicker.goToNextMonths;

  function handleDateChange(data) {
    if (!data.focusedInput) {
      setState(_objectSpread2({}, data, {
        focusedInput: START_DATE
      }));
    } else {
      setState(data);
    }
  }

  useEffect(function () {
    onChange(state);
  });
  return /*#__PURE__*/React.createElement(DatepickerContext.Provider, {
    value: {
      focusedDate: focusedDate,
      isDateFocused: isDateFocused,
      isDateSelected: isDateSelected,
      isDateHovered: isDateHovered,
      isDateBlocked: isDateBlocked,
      isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
      onDateSelect: onDateSelect,
      onDateFocus: onDateFocus,
      onDateHover: onDateHover
    }
  }, activeMonths.map(function (month) {
    return /*#__PURE__*/React.createElement(monthComponent.type, _extends({
      key: "".concat(month.year, "-").concat(month.month),
      year: month.year,
      month: month.month,
      firstDayOfWeek: firstDayOfWeek,
      onGoToNextMonths: goToNextMonths,
      onGoToPreviousMonths: goToPreviousMonths
    }, monthComponent.props));
  }));
}

Datepicker.defaultProps = {
  numberOfMonths: 1,
  minBookingDays: 1,
  exactMinBookingDays: true,
  initialVisibleMonth: new Date(),
  onChange: function onChange() {},
  monthComponent: /*#__PURE__*/React.createElement(Month, null)
};
Datepicker.propTypes = {
  numberOfMonths: PropTypes.number,
  minBookingDays: PropTypes.number,
  exactMinBookingDays: PropTypes.bool,
  initialVisibleMonth: PropTypes.object,
  onChange: PropTypes.func,
  monthComponent: PropTypes.node
};
Datepicker.Month = Month;
Datepicker.Day = Day;
Datepicker.Nav = Nav;

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 9500;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n  pointer-events: ", ";\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var StyledOffcanvasInner = styled(function (props) {
  return /*#__PURE__*/React.createElement(animated.div, props);
})(_templateObject$g(), function (props) {
  return props.direction === 'bottom' ? '0' : 0;
}, function (props) {
  return props.direction === 'top' ? '0' : 0;
}, function (props) {
  return props.direction === 'right' ? '0' : 0;
}, function (props) {
  return props.direction === 'left' ? '0' : 0;
}, function (props) {
  return props.show ? 'all' : 'none';
});

function OffCanvasInner(_ref) {
  var children = _ref.children,
      fromTop = _ref.fromTop,
      fromRight = _ref.fromRight,
      fromBottom = _ref.fromBottom,
      fromLeft = _ref.fromLeft,
      show = _ref.show,
      props = _objectWithoutProperties(_ref, ["children", "fromTop", "fromRight", "fromBottom", "fromLeft", "show"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      initialized = _useState2[0],
      setInitialized = _useState2[1];

  var direction;
  var transform = ['', ''];
  useEffect(function () {
    // Simple assertion of wether or not the component mounted.
    if (!initialized) setInitialized(true);
    return function cleanup() {};
  }, [initialized]);

  if (fromTop) {
    direction = 'top';
    transform = ['translateY(-100%)', 'translateY(0%)'];
  }

  if (fromBottom) {
    direction = 'bottom';
    transform = ['translateY(100%)', 'translateY(0%)'];
  }

  if (fromRight) {
    direction = 'right';
    transform = ['translateX(100%)', 'translateX(0%)'];
  }

  if (fromLeft) {
    direction = 'left';
    transform = ['translateX(-100%)', 'translateX(0%)'];
  } // Using array deconstruction, we can easily switch between transition states


  var _transform = transform,
      _transform2 = _slicedToArray(_transform, 2),
      from = _transform2[0],
      to = _transform2[1];

  if (!show) {
    var _transform3 = transform;

    var _transform4 = _slicedToArray(_transform3, 2);

    to = _transform4[0];
    from = _transform4[1];
  }

  var styleProps = useSpring({
    from: {
      transform: from
    },
    to: {
      transform: to
    },
    immediate: !initialized
  });
  return /*#__PURE__*/React.createElement(StyledOffcanvasInner, _extends({
    direction: direction,
    show: show ? 1 : 0,
    style: styleProps
  }, props), children);
}

OffCanvasInner.defaultProps = {
  show: false,
  fromTop: false,
  fromBottom: false,
  fromLeft: false,
  fromRight: false
};
OffCanvasInner.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool,
  fromTop: PropTypes.bool,
  fromBottom: PropTypes.bool,
  fromLeft: PropTypes.bool,
  fromRight: PropTypes.bool
};

var OffCanvas = /*#__PURE__*/function (_Component) {
  _inherits(OffCanvas, _Component);

  var _super = _createSuper(OffCanvas);

  function OffCanvas(props) {
    var _this;

    _classCallCheck(this, OffCanvas);

    _this = _super.call(this, props);
    _this.offcanvasRoot = document.querySelector(props.selector);
    return _this;
  }

  _createClass(OffCanvas, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["children"]);

      return ReactDOM.createPortal( /*#__PURE__*/React.createElement(OffCanvasInner, props, children), this.offcanvasRoot);
    }
  }]);

  return OffCanvas;
}(Component);

OffCanvas.defaultProps = {
  selector: '#root'
};
OffCanvas.propTypes = {
  children: PropTypes.node.isRequired,
  selector: PropTypes.string
};

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  padding: 1rem;\n  color: ", ";\n  border: 1px solid currentColor;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var StyledNavToggle = styled(Button)(_templateObject$h(), function (props) {
  return props.theme.baseBodyColor;
});

function NavigationToggle(_ref) {
  var children = _ref.children,
      withIcon = _ref.withIcon,
      withText = _ref.withText,
      onToggle = _ref.onToggle,
      props = _objectWithoutProperties(_ref, ["children", "withIcon", "withText", "onToggle"]);

  function renderInnerNavToggle() {
    if (withIcon !== null && withText !== null) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, withText), /*#__PURE__*/React.createElement(Icon, {
      icon: withIcon
    }));else if (withIcon === null && withText !== null) return /*#__PURE__*/React.createElement("span", null, withText);else if (withIcon !== null && withText === null) return /*#__PURE__*/React.createElement(Icon, {
      icon: withIcon
    });else return /*#__PURE__*/React.createElement(Icon, {
      icon: "menu"
    });
  }

  return /*#__PURE__*/React.createElement(StyledNavToggle, _extends({
    type: "button",
    icon: props.icon || withIcon === null && withText === null,
    onClick: onToggle
  }, props), children ? children : renderInnerNavToggle());
}

NavigationToggle.defaultProps = {
  withIcon: null,
  withText: null,
  children: null
};
NavigationToggle.propTypes = {
  withIcon: PropTypes.string,
  withText: PropTypes.string,
  children: PropTypes.node,
  onToggle: PropTypes.func.isRequired
};

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  padding: 1rem;\n  color: ", ";\n  border: 1px solid currentColor;\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var StyledNavToggle$1 = styled(Button)(_templateObject$i(), function (props) {
  return props.theme.baseBodyColor;
});

function NavigationUntoggle(_ref) {
  var withIcon = _ref.withIcon,
      withText = _ref.withText,
      onToggle = _ref.onToggle,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["withIcon", "withText", "onToggle", "children"]);

  function renderInnerNavToggle() {
    if (withIcon !== null && withText !== null) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, withText), /*#__PURE__*/React.createElement(Icon, {
      icon: withIcon
    }));else if (withIcon === null && withText !== null) return /*#__PURE__*/React.createElement("span", null, withText);else if (withIcon !== null && withText === null) return /*#__PURE__*/React.createElement(Icon, {
      icon: withIcon
    });else return /*#__PURE__*/React.createElement(Icon, {
      icon: "close"
    });
  }

  return /*#__PURE__*/React.createElement(StyledNavToggle$1, _extends({
    type: "button",
    icon: props.icon || withIcon === null && withText === null,
    onClick: onToggle
  }, props), children ? children : renderInnerNavToggle());
}

NavigationUntoggle.defaultProps = {
  withIcon: null,
  withText: null,
  children: null
};
NavigationUntoggle.propTypes = {
  withIcon: PropTypes.string,
  withText: PropTypes.string,
  children: PropTypes.node,
  onToggle: PropTypes.func.isRequired
};

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-transform: uppercase;\n  font-size: 1.4rem;\n  font-weight: bold;\n  padding: ", ";\n  border-bottom: ", ";\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  & + & {\n    margin-top: ", ";\n  }\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var StyledGroup = styled.ul(_templateObject$j(), function (props) {
  return props.theme.list.group.spacing;
});
var StyledTitle = styled.li(_templateObject2$6(), function (props) {
  return props.theme.list.item.padding;
}, function (props) {
  return props.theme.list.item.border;
});

function Group(_ref) {
  var title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["title", "children"]);

  return /*#__PURE__*/React.createElement(StyledGroup, props, title && /*#__PURE__*/React.createElement(StyledTitle, null, title), children);
}

Group.defaultProps = {
  title: null
};
Group.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  margin: 0;\n  position: absolute;\n  height: 100%;\n  opacity: ", ";\n  pointer-events: ", ";\n  transition: ease-out 0.2s all;\n  transform: ", ";\n\n  &:focus {\n    outline: 0;\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 4.4rem;\n  position: relative;\n  cursor: pointer;\n  padding: ", ";\n  background: ", ";\n  transition: ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  a {\n    color: currentColor;\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var StyledItem = styled.li(_templateObject$k(), function (props) {
  return props.theme.list.item.border;
});
var StyledTitle$1 = styled.span(_templateObject2$7(), function (props) {
  return props.theme.list.item.padding;
}, function (props) {
  return props.theme.list.item.bg;
}, function (props) {
  return props.theme.list.item.transition;
}, function (props) {
  return props.theme.list.item.bgHover;
});
var StyledCollapsible = styled.span(_templateObject3$2());
var StyledChildren = styled(Accordion)(_templateObject4$2());
var StyledIcon$1 = styled(Icon)(_templateObject5$1(), function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.show ? 'all' : 'none';
}, function (props) {
  return props.show ? 'rotateZ(0)' : 'rotateZ(-90deg)';
});

function Item(_ref) {
  var title = _ref.title,
      preToggled = _ref.toggled,
      openIcon = _ref.openIcon,
      closeIcon = _ref.closeIcon,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["title", "toggled", "openIcon", "closeIcon", "children"]);

  var _useState = useState(preToggled),
      _useState2 = _slicedToArray(_useState, 2),
      toggled = _useState2[0],
      setToggled = _useState2[1];

  function onClickHandler() {
    setToggled(function (prev) {
      return !prev;
    });
  }

  useEffect(function () {
    setToggled(preToggled);
  }, [setToggled, preToggled]);
  return /*#__PURE__*/React.createElement(StyledItem, props, /*#__PURE__*/React.createElement(StyledTitle$1, {
    hasChildren: !!children,
    onClick: onClickHandler
  }, title, children && /*#__PURE__*/React.createElement(StyledCollapsible, null, /*#__PURE__*/React.createElement(StyledIcon$1, {
    size: "sm",
    show: !toggled,
    icon: openIcon
  }), /*#__PURE__*/React.createElement(StyledIcon$1, {
    size: "sm",
    show: toggled,
    icon: closeIcon
  }))), children && /*#__PURE__*/React.createElement(StyledChildren, {
    toggled: toggled
  }, children));
}

Item.defaultProps = {
  toggled: false,
  openIcon: 'plus',
  closeIcon: 'minus',
  children: null
};
Item.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node.isRequired,
  toggled: PropTypes.bool,
  openIcon: PropTypes.string,
  closeIcon: PropTypes.string
};

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n\n  "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n    grid-template-areas: ", ";\n  "]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas: ", ";\n\n  ", "\n\n  ", ";\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}

var StyledParagraphImage = styled.section(_templateObject$l(), function (props) {
  return props.flip ? "\"paragraph\"\n         \"image\"" : "\"image\"\n         \"paragraph\"";
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject2$8(), props.flip ? "\"paragraph image\"" : "\"image paragraph\"");
}, function (props) {
  return props.theme.media.tablet_landscape_up(_templateObject3$3());
});

function ParagraphImage(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(StyledParagraphImage, props, children);
}

ParagraphImage.defaultProps = {
  flip: false
};
ParagraphImage.propTypes = {
  columns: PropTypes.number,
  flip: PropTypes.bool,
  children: PropTypes.node.isRequired
};

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

var StyledGridParagraph = styled.section(_templateObject$m(), function (props) {
  return props.gridPhone && "grid-template-areas: ".concat(props.flip || props.flipPhone ? "\"".concat(props.gridPhone.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridPhone, ";");
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject2$9(), props.gridTabletPortrait && "grid-template-areas: ".concat(props.flip || props.flipTabletPortrait ? "\"".concat(props.gridTabletPortrait.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridTabletPortrait, ";\n      ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridTabletPortrait.split(' ').length, ", 1fr);")));
}, function (props) {
  return props.theme.media.tablet_landscape_up(_templateObject3$4(), props.gridTabletLandscape && "grid-template-areas: ".concat(props.flip || props.flipTabletLandscape ? "\"".concat(props.gridTabletLandscape.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridTabletLandscape, ";\n      ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridTabletLandscape.split(' ').length, ", 1fr);")));
}, function (props) {
  return props.theme.media.desktop_up(_templateObject4$3(), props.gridDesktop && "grid-template-areas: ".concat(props.flip || props.flipDesktop ? "\"".concat(props.gridDesktop.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridDesktop, ";\n      ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridDesktop.split(' ').length, ", 1fr);"), "\n    "));
}, function (props) {
  return props.theme.media.big_desktop_up(_templateObject5$2(), props.gridBigDesktop && "grid-template-areas: ".concat(props.flip || props.flipBigDesktop ? "\"".concat(props.gridBigDesktop.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridBigDesktop, ";\n    ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridBigDesktop.split(' ').length, ", 1fr);")));
});

function GridParagraph(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  function anyGridIsInvalid(componentProps) {
    var gridPhone = componentProps.gridPhone,
        gridTabletPortrait = componentProps.gridTabletPortrait,
        gridTabletLandscape = componentProps.gridTabletLandscape,
        gridDesktop = componentProps.gridDesktop,
        gridBigDesktop = componentProps.gridBigDesktop;
    var grids = [gridPhone, gridTabletPortrait, gridTabletLandscape, gridDesktop, gridBigDesktop].filter(Boolean) // Filter nulls
    .map(function (grid) {
      return (!grid.startsWith("\"") || !grid.endsWith("\"")) && grid;
    }).filter(Boolean);

    if (grids.length > 0) {
      console.error('Error: Some GridParagraph grid templates are invalid.', grids);
      return true;
    }

    return false;
  }

  if (anyGridIsInvalid(props)) return null;
  return /*#__PURE__*/React.createElement(StyledGridParagraph, props, children);
}

GridParagraph.defaultProps = {
  gridPhone: null,
  gridTabletPortrait: null,
  gridTabletLandscape: null,
  gridDesktop: null,
  gridBigDesktop: null,
  useFractions: false,
  flip: false,
  flipPhone: false,
  flipTabletPortrait: false,
  flipTabletLandscape: false,
  flipDesktop: false,
  flipBigDesktop: false
};
GridParagraph.propTypes = {
  gridPhone: PropTypes.string,
  gridTabletPortrait: PropTypes.string,
  gridTabletLandscape: PropTypes.string,
  gridDesktop: PropTypes.string,
  gridBigDesktop: PropTypes.string,
  useFractions: PropTypes.bool,
  flip: PropTypes.bool,
  flipPhone: PropTypes.bool,
  flipTabletPortrait: PropTypes.bool,
  flipTabletLandscape: PropTypes.bool,
  flipDesktop: PropTypes.bool,
  flipBigDesktop: PropTypes.bool,
  children: PropTypes.node.isRequired
};
export { Accordion, Button, Card, Checkbox, Datepicker, ErrorMessage, Expander, FormField, FormLabel, GridParagraph, Icon, Input, Group as ListGroup, Item as ListItem, NavigationToggle as NavToggle, NavigationUntoggle as NavUntoggle, OffCanvas, ParagraphImage, Select, Textarea, ValidationInput };